export enum StoreStatus {
  IsLoading = 'IsLoading',
  IsSuccess = 'IsSuccess',
  IsError = 'IsError',
}
